import { CompatibleOptionsResponse } from "../../types/BFFServiceTypes";

const FIELD_SEPARATOR = "$$";
const KEY_VALUE_SEPARATOR = "::";
const ARRAY_ENTRY_SEPARATOR = "||";

type CacheType = CompatibleOptionsResponse;

// This class represents the current BFF state.
export class BFFCache {
  private data: { [serializedKey: string]: CacheType };
  private static instance: BFFCache;

  private constructor() {
    this.data = {};
  }

  static getInstance(): BFFCache {
    if (!BFFCache.instance) {
      BFFCache.instance = new BFFCache();
    }
    return BFFCache.instance;
  }

  serializeBFFKey(key: BFFKey): string {
    const serializedSelectionsArray = Object.keys(key.selections)
      .sort()
      .map(property => `${property}${KEY_VALUE_SEPARATOR}${key.selections[property]}`);
    const serializedSelections = serializedSelectionsArray.join(ARRAY_ENTRY_SEPARATOR);

    const serializedKey = `ProductKey${KEY_VALUE_SEPARATOR}${key.productKey}Locale${KEY_VALUE_SEPARATOR}${key.locale}Selections${KEY_VALUE_SEPARATOR}${serializedSelections}${FIELD_SEPARATOR}SelectedQuantity${KEY_VALUE_SEPARATOR}${key.selectedQuantity}${FIELD_SEPARATOR}PricingContext${KEY_VALUE_SEPARATOR}${key.pricingContext}`;

    return serializedKey;
  }

  addData({
    productKey,
    locale,
    selections,
    selectedQuantity,
    pricingContext,
    data,
  }: BFFKey & { data: CacheType }): void {
    const serializedKey = this.serializeBFFKey({
      productKey,
      locale,
      selections,
      selectedQuantity,
      pricingContext,
    });
    if (!Object.prototype.hasOwnProperty.call(this.data, serializedKey)) {
      this.data[serializedKey] = data;
    }
  }

  getData({
    productKey,
    locale,
    selections,
    selectedQuantity,
    pricingContext,
  }: BFFKey): CacheType | undefined {
    const serializedKey = this.serializeBFFKey({
      productKey,
      locale,
      selections,
      selectedQuantity,
      pricingContext,
    });
    if (Object.keys(this.data).includes(serializedKey)) {
      return this.data[serializedKey];
    }

    return undefined;
  }
}

export interface BFFKey {
  productKey: string;
  locale: string;
  selections: { [key: string]: string };
  selectedQuantity?: number;
  pricingContext: string;
}
